import { createAsyncThunk } from '@reduxjs/toolkit'
import railsApiService from 'services/api/rails-api-service'

interface ConsultationApplyCouponParams {
  coupon: string
  order_number: string
}

export const consultationApplyCoupon = createAsyncThunk(
  'consultation-apply-coupon',
  async (params: ConsultationApplyCouponParams, { rejectWithValue }) => {
    try {
      const { data } = await railsApiService.apiInstance.post<{
        total: string
      }>('/api/v1/consultations/apply_coupon', params)

      return data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
